import Base from './components/cells/Base';
import FullWidthDivider from './components/cells/FullWidthDivider';

export default function FullWidthDividerCell() {}

FullWidthDividerCell.prototype.init = function (params) {
    this.eGui = Base(FullWidthDivider(params), params);
};

FullWidthDividerCell.prototype.getGui = function () {
    return this.eGui;
};
